<template>
    <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
                <h3 class="text-lg font-semibold text-gray-900">Cancel Pro subscription</h3>
                <p v-if="isCancelling" class="mt-2 text-sm text-gray-600">
                    Your Pro plan ends on <span class="font-semibold">{{ endsOn }}</span>.
                    After that your account moves to Basic (free) and your properties are kept.
                </p>
                <p v-else class="mt-2 text-sm text-gray-600">
                    You'll keep Pro features until <span class="font-semibold">{{ renewalDate }}</span>,
                    then move to Basic (free). Your properties, tenants and listings stay in your account.
                </p>
            </div>
            <button
                v-if="isCancelling"
                type="button"
                class="primaryButton !mt-0 shrink-0"
                :disabled="isSubmitting"
                @click="$emit('resume')"
            >
                Resume subscription
            </button>
            <button
                v-else
                type="button"
                class="whiteButton !mt-0 shrink-0"
                :disabled="isSubmitting"
                @click="$emit('cancel')"
            >
                Cancel subscription
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CancelProCard',
    props: {
        proPlan: {
            type: Object,
            default: null,
        },
        isSubmitting: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'resume'],
    computed: {
        isCancelling() {
            return Boolean(this.proPlan?.is_cancelling);
        },
        endsOn() {
            const date = this.proPlan?.cancel_at ?? this.proPlan?.renewal_date;

            return date ? new Date(date).toLocaleDateString() : '—';
        },
        renewalDate() {
            return this.proPlan?.renewal_date ? new Date(this.proPlan.renewal_date).toLocaleDateString() : '—';
        },
    },
};
</script>
